import NewselaGlobalLayout from "@/base";
import NotAllowedError from "@/errors/NotAllowedError";
import NotLoggedInError from "@/errors/NotLoggedInError";
import getUserProperties from "@/users/getUserProperties";

const withAdminContentPrivileges = (ComponentToWrap) => {
  const WrappedWithApprovedAdmin = ({ RootProvidersInitialProps }) => {
    const user =
      RootProvidersInitialProps?.userProviderProps?.userQueryInitialValue?.data;
    const { isAuthenticatedUser, canViewContentSettings } =
      getUserProperties(user);

    return (
      (!isAuthenticatedUser && (
        // Renders the unauthenticated State
        <NewselaGlobalLayout mainContents={<NotLoggedInError />} />
      )) ||
      // Renders the Admin (District and School admin or Principal) State
      (canViewContentSettings && <ComponentToWrap user={user} />) || (
        // Renders Authenticated Non-Admin (Teachers and Students) State
        <NewselaGlobalLayout mainContents={<NotAllowedError />} />
      )
    );
  };

  return WrappedWithApprovedAdmin;
};

export default withAdminContentPrivileges;
